export default __webpack_public_path__ + "static/media/logo-md-768w.fd71c121.webp";